<template>
    <v-container fluid class="px-0">
        <v-list flat>
            <v-list-item three-line>
                <v-list-item-avatar>
                    <v-icon style="background-color: gainsboro !important; color: black;">mdi-clock-time-two</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        <strong style="font-size: 1rem;">Invoice Log</strong>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <v-tabs
                            v-model="tab"
                            ref="tabs"
                            show-arrows
                        >
                            <v-tab
                                v-for="(item, index) in tabs"
                                :key="item.id || index"
                                class="text-none mr-2"
                                style="letter-spacing: 0.50px;"
                            >
                                <small style="font-weight: 900; font-size: 0.8rem;">{{ item.tab }}</small>
                            </v-tab>
                        </v-tabs>
                        <v-divider/>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-tabs-items
            v-model="tab"
        >
            <v-tab-item>
                <!-- personal -->
                <TreeViewTable
                    :tasks="personalTasks"
                    :header="header_personal"
                    :getStatuses="getStatuses"
                />
            </v-tab-item>
            <v-tab-item>
                <!-- assigned tasks -->
                <CompanyTreeView
                    :tasks="assignedTasks"
                    :header="header_assigned"
                    :getStatuses="getStatuses"
                />
            </v-tab-item>
            <v-tab-item>
                <!-- <GoalTreeView
                    :tasks="groupedGoals"
                    :header="header_goal"
                /> -->
            </v-tab-item>
        </v-tabs-items>
        
    </v-container>
</template>

<script>
/**vuex */
import { mapGetters } from 'vuex';

/**components */
import TreeViewTable from '../modules/TreeViewTable.vue';
import CompanyTreeView from './component/CompanyTreeView.vue';
// import GoalTreeView from './component/GoalTreeView.vue';

export default {
    name: 'TimeTrackComponent',
    components: {
        TreeViewTable,
        CompanyTreeView,
        // GoalTreeView
    },
    data: () => ({
        header_personal: [
            { text: "Creator", value: "creator", width: '5%' },
            { text: "Task", value: "name", width: '30%' },
            { text: "Company", value: "company", width: '10%' },
            { text: "Allocated time", value: "allocated_time", width: '10%'},
            { text: 'Actual time', value: "actual_time", width: '10%' }
        ],
        header_assigned: [
            { text: "Creator", value: "creator", width: '5%' },
            { text: "Task", value: "name", width: '30%' },
            { text: "Status", value: "status", width: '10%' },
            { text: "Allocated time", value: "allocated_time", width: '10%'},
            { text: 'Actual time', value: "actual_time", width: '10%' }
        ],
        header_goal: [
            { text: "Goal Title", value: "title", width: '30%' },
            { text: "Members", value: "members", width: '10%' }
        ],
        tab: 0,
        tabs: [
            { tab: "Personal Tasks"},
            { tab: "Assigned Tasks" },
            // { tab: "Goals" }
        ],
    }),
    async mounted() {
        document.title = "DG Tasks - Work Logs";
        await Promise.all([
            this.getMyTasks(),
            this.getStatus(),
            this.getPersonalGoals()
        ]);
        const tabsElement = this.$refs.tabs?.$el;
        if (tabsElement) {
            tabsElement.addEventListener("touchstart", this.preventSwipe, { passive: false });
            tabsElement.addEventListener("touchmove", this.preventSwipe, { passive: false });
        }
    },
    beforeDestroy() {
        const tabsElement = this.$refs.tabs?.$el;
        if (tabsElement) {
            tabsElement.removeEventListener("touchstart", this.preventSwipe);
            tabsElement.removeEventListener("touchmove", this.preventSwipe);
        }
    },
    computed: {
        ...mapGetters({
            personalTasks:  'timetrack/getPersonalTasks',
            assignedTasks:  'timetrack/getAssignedTasks',
            getStatuses:    'tasks/get_statuses',
            groupedGoals:   "goal/getGroupedGoals"
        }),
    },
    methods: {
        preventSwipe(event) {
            event.preventDefault();
        },

        // Moved from misc.service.js
        async getStatus(){
            try{
                const response = await this.$axios.get('/api/misc/get_status')
                const { data } = response
                this.$store.commit('tasks/set_statuses', data)
            }catch(error){
                console.log('error on fetching status - service layer', error)
            }
        },

        async getPriorities(){
            try{
                const response = await this.$axios.get('/api/misc/get_prority')
                const { data } = response
                this.$store.commit('tasks/set_priorities', data)
            }catch(error){
                console.log('error on fetching priorities - service layer', error)
            }
        },

        /**
         * add description to a task
         * @params
         * data?: object
         * - record_id?: int
         * - description>L string
         */
        async addDescriptionAPI(data){
            try{
                await this.$axios.post('/api/misc/add_description', data)
                return true;
            }catch(error){
                console.log("error on adding description - service layer", error)
            }
        },

        // Moved from goal.service.js (only what's needed)
        /**
         * get personal goals
         */
        async getPersonalGoals(){
            try{
                const response = await this.$axios.get('api/goals')
                const { data } = response
                this.$store.commit('goal/setPersonalGoals', data)

                // grouped goals
                const groupedGoals = data.reduce((acc, goal) => {
                    const privacyName = goal.privacy.name;
            
                    if (!acc[privacyName]) {
                        acc[privacyName] = [];
                    }
            
                    acc[privacyName].push(goal);
                    return acc;
                }, {});

                const groupedGoalsArray = Object.keys(groupedGoals).map((key, index) => ({
                    id: index + 1,
                    name: key,
                    items: groupedGoals[key]
                }));

                this.$store.commit("goal/setGroupedGoals", groupedGoalsArray)

            }catch(error){
                console.log('error on fetching personal goals - service layer', error)
            }
        },

        // Moved from dashboard.service.js
        async getMyTasks() {
            try {
                const user = this.$store.getters["auth/get_user"];
                const selectedUser = this.$store.getters["tasks/getUserId"];
                if (Object.keys(selectedUser).length == 0) {
                    this.$store.commit("tasks/SET_USER_ID", user);
                }
                const company = this.$store.getters["companies/get_selected_company"];
                const statuses = this.$store.getters["tasks/get_statuses"];
                
                // Use default priorities and statuses for timetrack
                const selected_assign_filters = {
                    priorities: this.get_selected_priorities || [1, 2, 3, 4, null],
                    statuses: this.get_statuses || [1, 2, 3, 4, null],
                };
                
                // Ensure statuses and priorities are flat arrays
                const flattenedStatuses = Array.isArray(selected_assign_filters.statuses) 
                    ? selected_assign_filters.statuses.flat() 
                    : [];
                const flattenedPriorities = Array.isArray(selected_assign_filters.priorities)
                    ? selected_assign_filters.priorities.flat()
                    : [];

                const response = await this.$axios.get("api/tasks/get_my_tasks", {
                    params: {
                        user_id:
                            Object.keys(selectedUser).length > 0 ? selectedUser.id : user.id,
                        assignee_id:
                            Object.keys(selectedUser).length > 0 ? selectedUser.id : user.id,
                        company_id: company.id,
                        selected_assign_filter: "All",
                        statuses: JSON.stringify(flattenedStatuses),
                        priority: JSON.stringify(flattenedPriorities),
                    },
                });
                
                const { data } = response;

                // Data is now managed through centralized DefaultLayout
                // let joineedtasks = [...data.assigned_tasks, ...data.personal_tasks];

                const filteredAssignedTasks = data.assigned_tasks.filter(
                    (t) =>
                        selected_assign_filters.statuses.includes(t.status_id) &&
                        selected_assign_filters.priorities.includes(t.priority_id)
                );

                const groupedAssignedTasks = filteredAssignedTasks.reduce((acc, task) => {
                    // Find the group by company_id
                    const group = acc.find((g) => g.company_id === task.company_id);

                    if (group) {
                        group.tasks.push(task);
                        group.total_allocated_time = this.sumTime(
                            group.total_allocated_time || "00:00:00",
                            task.allocated_time
                        );
                    } else {
                        acc.push({
                            company_id: task.company_id,
                            name: task.company?.name ?? "no company",
                            tasks: [task],
                            total_allocated_time: task.allocated_time,
                        });
                    }

                    return acc;
                }, []);
                this.$store.commit("timetrack/SET_ASSIGNED_TASKS", groupedAssignedTasks);
                this.$store.commit("tasks/SET_ASSIGNED_TASKS", groupedAssignedTasks);

                const filteredPersonalTasks = data.personal_tasks.filter(
                    (t) =>
                        selected_assign_filters.statuses.includes(t.status_id) &&
                        selected_assign_filters.priorities.includes(t.priority_id)
                );

                const groupedPersonalTasks = filteredPersonalTasks.reduce((acc, task) => {
                    let group = acc.find((g) => g.status_id === task.status_id);

                    if (group) {
                        group.tasks.push(task);
                        group.total_allocated_time = this.sumTime(
                            group.total_allocated_time || "00:00:00",
                            task.allocated_time
                        );
                    } else {
                        const status = statuses.find((s) => s.id === task.status_id) || {};
                        acc.push({
                            status_id: task.status_id,
                            name: status.name || "(Unknown Status)",
                            tasks: [task],
                            total_allocated_time: task.allocated_time,
                        });
                    }
                    return acc;
                }, []);

                this.$store.commit("timetrack/SET_PERSONAL_TASKS", groupedPersonalTasks);
                this.$store.commit("tasks/SET_PERSONAL_TASKS", groupedPersonalTasks);
            } catch (error) {
                console.log("error fetching get my tasks - service layer", error);
            }
        },

        sumTime(time1, time2) {
            const [h1, m1, s1] = time1.split(":").map(Number);
            const [h2, m2, s2] = time2.split(":").map(Number);

            let totalSeconds = h1 * 3600 + m1 * 60 + s1 + (h2 * 3600 + m2 * 60 + s2);

            const hours = Math.floor(totalSeconds / 3600);
            totalSeconds %= 3600;
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;

            return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
                2,
                "0"
            )}:${String(seconds).padStart(2, "0")}`;
        }
    }
};
</script>